import { useMemo } from 'react';
import { visibleMenu } from '@platform/authz';
import { useSession } from "../auth/session.js";
/**
 * `@platform/authz`'s `visibleMenu` over the session principal. Items carry whatever the shell
 * needs (label, icon, href) on top of `{ id, action?, auth?, children? }`; an item without an
 * action is a group and disappears with its last child.
 */
export function useVisibleMenu(items) {
    const { principal } = useSession();
    return useMemo(() => (principal ? visibleMenu(principal, items) : []), [principal, items]);
}
//# sourceMappingURL=menu.js.map